










import {
  computed,
  defineComponent,
  onMounted,
  useContext,
  useRoute,
} from '@nuxtjs/composition-api';
import { useUser } from '@unified-commerce/gpc-vue-storefront-shopify';
import { getStoryBlokVersion, useContent } from '@unified-commerce/gpc-vue-storefront-storyblok';

import AppFooterView from './AppFooterView.vue';
import { getAccountMenuItems } from './helpers/getAccountMenuItems';
import type { SimpleMenuLink, SocialMediaLink } from './types';

export default defineComponent({
  components: {
    AppFooterView,
  },
  setup() {
    const { $config } = useContext();
    const route = useRoute();
    const { search, content = {} } = useContent('footerMenuContent');
    const { load: loadUser, user } = useUser();

    const mainMenuItems = computed<SimpleMenuLink>(() => content.value.about);
    const helpSupportMenuItems = computed<SimpleMenuLink>(() => content.value.helpSupport);
    const socialMediaMenuItems = computed<SocialMediaLink>(() => content.value.socialMedia);
    const accountMenuItems = computed<SimpleMenuLink[]>(() =>
      getAccountMenuItems(user.value, content.value),
    );

    const shopMenuItems = computed<SimpleMenuLink>(() => content.value.shop);

    onMounted(async () => {
      search({
        url: `navigation-menus/footer`,
        version: getStoryBlokVersion($config.ENV, route.value),
      });
      if (!user) {
        await loadUser();
      }
    });

    return {
      content,
      mainMenuItems,
      helpSupportMenuItems,
      socialMediaMenuItems,
      accountMenuItems,
      shopMenuItems,
    };
  },
});
